export enum PaymentRecordFormFields {
    AMOUNT = 'amount',
    CURRENCY = 'currency',
    PAYMENT_DATE = 'paymentDate',
}
